var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quickscan-finish"},[_c('h1',[_vm._v("Aanvraag quickscan")]),_c('h2',[_vm._v("Verzenden")]),_c('quickscan-stepper',{attrs:{"current-step":3,"loading":!_vm.loaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }